import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { noop } from "rxjs";
import { AlertService } from "../alerts/alert.service";
import { ConfigurationService } from "../configuration/configuration.service";
import { LoggingService } from "../logging/logging.service";
import { LogEventType } from "../logging/models/log-event-type.enum";
import { LogSourceLevel } from "../logging/models/log-source-level.enum";
import { Severity } from "../logging/models/severity.enum";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlingService extends ErrorHandler {
  serviceName = "ErrorHandlingService";
  errorHandlingConfig;

  constructor(
    private loggingService: LoggingService,
    private configurationService: ConfigurationService,
    private alertService: AlertService,
    private translate: TranslateService,
    private router: Router
  ) {
    super();
    // console.log("In Errorhanding, constructor ");
  }

  // On handle error
  handleError(error: Error | HttpErrorResponse): any {
    // In error handling
    // console.log("In Errorhanding, handleerror ");

    this.errorHandlingConfig =
      this.configurationService.applicationConfiguration.errorHandling;

    if (this.errorHandlingConfig.includeDefaultErrorHandling) {
      // use the [super] call to keep default error handling functionality --> console;
      super.handleError(error);
    }

    console.log(`current error =======>`);
    console.log(error);

    // console.log(JSON.stringify(error.developerMessage));
    // A. HANDLE ERRORS FROM HTTP
    console.log(error);
    if (error instanceof HttpErrorResponse) {
      console.log(error);
      if (error.error instanceof ErrorEvent) {
        // A.1: A client-side or network error occurred. Handle it accordingly.
        // const formattedError = `${error.error.e}; ${error.message}`;
        // const formattedError = `${error.developerMessage}; ${error.message}`;

        //const formattedError = `errorCodes.${error.errorCodes[0]}`;
        //const formattedError= this.translate.instant(formattedError);
        const formattedError = error.error["userMessage"];
        console.log(formattedError);
        this.alertService.error(formattedError);

        //    this.loggingService.log(this.serviceName, LogEventType.Error, LogSourceLevel.Start, Severity.Error, formattedError, "clientRefCode")
        console.log("ZPI AAAAAAAA1 ---------------------In Error handler, ");
      } else {
        // A.2: The API returned an unsuccessful response (i.e., 400, 401, 403, etc.).
        /**
         * The [HttpService] should return a response that is consumable by the caller
         * of the API. The response should include relevant information and error messages
         * in a format that is known and consumable by the caller of the API.
         */
        console.log("ZPI AAAAAAAA2 ---------------------In Error handler, ");

        if ([401, 403].includes(error.status)) {
          // auto logout if 401 or 403 response returned from api
          const formattedError = error.error["userMessage"]
            ? error.error["userMessage"]
            : error.error["message"];
          this.router.navigate(["/login"]);
          return;
        }

        if (error && error.error) {
          console.log(error);

          //const formattedError = `errorCodes.${error.errorCodes[0]}`;
          //const formattedError= this.translate.instant(formattedError);
          const formattedError = error.error.userMessage;
          console.log(formattedError);
          this.alertService.error(formattedError);
          noop();
          return;
        } else {
          //const formattedError = `errorCodes.${error.errorCodes[0]}`;
          //const formattedError= this.translate.instant(formattedError);
          const formattedError = error.error["userMessage"];
          console.log(formattedError);
          this.alertService.error(formattedError);
          //  this.loggingService.log(this.serviceName, LogEventType.Error, LogSourceLevel.Start, Severity.Error, formattedError, "clientRefCode")
          noop();
        }
      }
    } else {
      // B. HANDLE A GENERALIZED ERROR FROM THE APPLICATION/CLIENT;
      console.log(error);

      //Json check value -->
      //const formattedError = `errorCodes.${error.errorCodes[0]}`;
      const formattedError = error["error"]["userMessage"];
      console.log(formattedError);
      console.log(
        "ZPI BBBBBBBBB ---------------------In Error handler, " + formattedError
      );
      //const formattedError= this.translate.instant(formattedError);
      this.alertService.error(formattedError);
      // this.loggingService.log(this.serviceName, LogEventType.Error, LogSourceLevel.Start, Severity.Error, formattedError, "clientRefCode")
    }
  }
}
